import React from 'react';
import OrderList from './OrderList';

export const ZSOrderList = props => (<OrderList {...props} />);
